<template>
  <el-container class="home-container">
    <el-header class="home-header">
      <img src="@/assets/images/logo.png" alt="">
      <span>出货物料单管理系统</span>
      <el-dropdown>
        <span class="el-dropdown-link">
          {{nickName}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span @click="unlogin">退出</span>
          </el-dropdown-item>
           <el-dropdown-item>
            <span @click="restPassword">修改密码</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <el-container>
      <el-main>
        <el-card shadow="never" class="box-card">
          <div class="add-client-wrap">
            <div class="title">出货物料单</div>
          </div>
          <el-tabs v-model="activeName">
            <el-tab-pane
              v-for="(item, index) in groupBySaleList"
              :key="index"
              :label="item.sale"
              :name="String(index)">
              <el-table
                :data="item.moInfos"
                style="width: 100%">
                <el-table-column
                  prop="moNumber"
                  label="物料单号">
                </el-table-column>
                <el-table-column
                  prop="moType"
                  label="物料单类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.moType==1">订单</span>
                    <span v-if="scope.row.moType==2">样品</span>
                    <span v-if="scope.row.moType==3">外借</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="systemType"
                  label="子系统类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.systemType==1">太阳能</span>
                    <span v-if="scope.row.systemType==2">市电</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="moStatus"
                  label="物料单状态">
                  <template slot-scope="scope">
                    <el-tag type="warning" v-if="scope.row.moStatus==0">待出货</el-tag>
                    <el-tag type="success" v-if="scope.row.moStatus==1">已出货</el-tag>
                    <el-tag type="info" v-if="scope.row.moStatus==2">已撤销</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createdAt"
                  label="提单时间">
                  <template slot-scope="scope">
                    {{scope.row.createdAt | time}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="shipmentTime"
                  label="出货时间">
                  <template slot-scope="scope">
                    {{scope.row.shipmentTime | time}}
                  </template>
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="200">
                <template slot-scope="scope">
                  <el-button @click="openDetail(scope.row)" type="text" size="small">查看详情</el-button>
                </template>
              </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <el-dialog
          title="出货物料单详情"
          :visible.sync="dialogVisible"
          width="500px">
          <detail :moDdetail="moDdetail"></detail>
        </el-dialog>
        <!-- 修改密码 -->
        <el-dialog
          title="修改密码"
          :visible.sync="resetPasswordDialog"
          :close-on-click-modal="false"
          width="30%">
          <el-form label-width="80px">
            <el-form-item label="旧密码">
              <el-input type="password" v-model.trim="password.old"></el-input>
            </el-form-item>
            <el-form-item label="新密码">
              <el-input type="password" v-model.trim="password.new"></el-input>
            </el-form-item>
            <el-form-item label="确认密码">
              <el-input type="password" v-model.trim="password.confirm"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="resetPasswordBtn" type="success">确认修改</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-main>
    </el-container>
    <el-footer class="home-footer">©Coyperight2016-2018华泉出货管理系统</el-footer>
  </el-container>
</template>

<script>
import '@/assets/stylus/home.styl';
import detail from './detail';
import http from 'http';

export default {
  components: {
    detail
  },
  data () {
    return {
      activeName: '0',
      groupBySaleList: [],
      systemList: [],
      dialogVisible: false,
      moDdetail: {},
      pageSize: 10,
      currentPage: 1,
      password: {
        old: '',
        new: '',
        confirm: ''
      },
      resetPasswordDialog: false,
      nickName: '',
      username: ''
    };
  },
  computed: {
  },
  methods: {
    getSystemName (id) {
      // return this.systemList.filter(item => item.id === id)[0].name;
      let systemInfo = this.systemList.filter(item => item.id === id)[0];
      if (systemInfo) {
        return systemInfo.name;
      } else {
        return '--';
      }
    },
    currentChange (val) {
      this.currentPage = val;
    },
    openDetail (detail) {
      this.dialogVisible = true;
      this.moDdetail = detail;
    },
    // 按销售分组获取出货物料单列表
    async getGroupBySaleList () {
      let { data } = await http.get(`/v1/mo-infos/group-by-sale`);
      this.groupBySaleList = data;
    },
    // 退出登录
    unlogin () {
      this.$store.commit('updateToken', '');
      sessionStorage.clear();
      this.$router.push({name: 'login'});
    },
    async resetPasswordBtn () {
      if (this.password.new.length < 6 || this.password.new.length > 16) {
        this.$message({
          message: '密码长度为6-16个字符',
          type: 'warning'
        });
        return false;
      }
      if (this.password.new !== this.password.confirm) {
        this.$message({
          message: '两次输入的新密码不同',
          type: 'warning'
        });
        return false;
      }
      let { data } = await http.post(`/v1/me/password`, {
        oldPassword: this.password.old,
        newPassword: this.password.new
      });
      if (data.success === true) {
        this.$message({
          message: '密码修改成功',
          type: 'success'
        });
        this.resetPasswordDialog = false;
        this.$router.push({name: 'login'});
      }
    },
    restPassword () {
      this.resetPasswordDialog = true;
    }
  },
  async created () {
    // 获取用户列表
    this.getGroupBySaleList();
    try {
      this.nickName = JSON.parse(sessionStorage.getItem('userInfo')).nickname || '华泉智能';
      this.username = JSON.parse(sessionStorage.getItem('userInfo')).username || '';
    } catch (e) {
    }
  }
};
</script>

<style scoped>
.el-dialog .el-cascader {
  margin-bottom: 7px;
  width: 100%;
}
.dialog-item {
  color: #999;
  line-height: 32px;
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/monitor/index.vue